import React from "react";
import { TagsData } from "src/shared/types/src";

type IProps = {
    tags: TagsData[]
}

const TagListRenderer: React.FC<IProps> = ({ tags }) => {
    return (
        <div className="d-flex align-items-center gap-2 mg-t-15 flex-wrap">
            {
                tags?.map((tag, index) =>
                    <div key={index} className="tag-outline">
                        <span className="tag-dot tag-dot-print" style={{ color: tag.color }}>●</span>
                        <span className="tag-dot print-element-hide" style={{ background: tag.color }}></span>
                        <p className="tag-text fs-10 text-black mb-0 flex-1">{ tag.label }</p>
                    </div>
                )
            }
        </div>
    )
}

export default TagListRenderer;